// extracted by mini-css-extract-plugin
module.exports = {"container":"sq","links":"tq"};